import CancelAssessment from "../../../../assets/images/pre-assessment.svg";
import { getTranslatedText } from "../../../../utils/getTranslatedText";

import Modal from "../../../modal/Modal";

import Button from "../ButtonComponent";

import { BUTTON_VARIANTS } from "../constant";
import { useGetTranslatedText } from "../queries";

import styles from "./styles.module.scss";

const MandatoryAssessmentModal = (props) => {
  const { show, handleContinueAssessment } = props;

  const languageId = localStorage.getItem("l_id") || 1;

  const { data: translatedTextResponse } =
    useGetTranslatedText(languageId);

  const { data: translatedText = [] } =
    translatedTextResponse || {};

  return (
    <Modal visible={show}>
      <div className={styles["mandatory-wrapper"]}>
        <div className={styles["success-image"]}>
          <img src={CancelAssessment} alt="assessment" />
        </div>
        <div className={styles.title}>
          {getTranslatedText(
            translatedText,
            "key_assessment_mandatory",
            "Assessment is Mandatory"
          )}
        </div>
        <div className={styles.description}>
          {getTranslatedText(
            translatedText,
            "key_assessment_mandatory_description",
            "You must submit this assessment to continue learning."
          )}
        </div>

        <div className={styles["button-wrapper"]}>
          <Button
            label={getTranslatedText(
              translatedText,
              "label_continue",
              "Continue"
            )}
            buttonVariant={BUTTON_VARIANTS.PRIMARY}
            onClick={handleContinueAssessment}
          />
        </div>
      </div>
    </Modal>
  );
};

export default MandatoryAssessmentModal;
